import { MinervaReferenceData } from '../minerva-reference-data.model';

// export const DUAL_GARAGE_DISTRICT: string = 'DUAL_GARAGE_DISTRICT';
// export const DISTRICT_GARAGE: string = 'DISTRICT_GARAGE';
// export const BCC_BORO: string = 'BCC_BORO';
// export const DISTRICT: string = 'DISTRICT';

export class MinervaLocation extends MinervaReferenceData {
  locationTypeId: string;
  rollsUpTo: string;
  workUnit: string;

  // tslint:disable-next-line
  constructor(location: any) {
    super(location);
    this.locationTypeId = location.locationTypeId;
    this.rollsUpTo = location.rollsUpTo;
    this.workUnit = location.workUnit;
  }

  get label(): string {
    return this.code;
  }
}
